import { pxToRem } from './pxToRem';
export function responsiveCssProperties(property, valueOrReplacements, replacements) {
    if (typeof property !== 'string') {
        return Object.entries(property).reduce((style, [property, $value]) => {
            Object.assign(style, responsiveCssProperties(property, $value, valueOrReplacements));
            return style;
        }, {});
    }
    if (typeof valueOrReplacements === 'string' ||
        typeof valueOrReplacements === 'number' ||
        Array.isArray(valueOrReplacements)) {
        return {
            [property]: cssProperty(property, valueOrReplacements, replacements),
        };
    }
    if (typeof valueOrReplacements === 'object') {
        return Object.keys(valueOrReplacements).reduce((style, size) => {
            style[size === 'base' ? property : `${property}-${kebabCase(size)}`] =
                cssProperty(property, valueOrReplacements[size], replacements);
            return style;
        }, {});
    }
    return {};
}
function cssProperty(property, value, replacements = {}) {
    if (Array.isArray(value)) {
        return value
            .map((value) => {
            const propertyValue = cssProperty(property, value, replacements);
            return /grid-areas/.test(property)
                ? `"${propertyValue}"`
                : propertyValue;
        })
            .join(' ');
    }
    if (typeof value === 'string' && Object.keys(replacements).includes(value)) {
        return replacements[value];
    }
    if (typeof value === 'string' &&
        /^space-[0-9]+|^font-size-[0-9]+/.test(value)) {
        return `var(--mollie-ui-${value})`;
    }
    if (typeof value === 'string' &&
        /white|black|blue-|gray-|green-|red-|yellow-|purple-/.test(value)) {
        return ((/border/.test(property) ? 'solid ' : '') +
            `var(--mollie-ui-color-palette-${value})`);
    }
    if (!(typeof value === 'string' && value.charAt(0) === '#') &&
        /background/.test(property)) {
        return `var(--mollie-ui-color-background-${value})`;
    }
    if (!(typeof value === 'string' && value.charAt(0) === '#') &&
        /color/.test(property) &&
        property !== '--mollie-ui-badge-color') {
        return `var(--mollie-ui-color-typography-${value})`;
    }
    if (/font-family/.test(property)) {
        return `var(--mollie-ui-font-family-${value})`;
    }
    if (/font-weight/.test(property)) {
        return `var(--mollie-ui-font-weight-${value})`;
    }
    if (/letter-spacing/.test(property)) {
        return `var(--mollie-ui-letter-spacing-${value})`;
    }
    if (/line-height/.test(property)) {
        return `var(--mollie-ui-line-height-${value})`;
    }
    if (/border-[a-z-]+-width/.test(property)) {
        return `var(--mollie-ui-border-width-${value})`;
    }
    if (/border-radius/.test(property)) {
        return `var(--mollie-ui-border-radius-${value})`;
    }
    if (/border/.test(property)) {
        return `solid ${typeof value === 'string' &&
            /positive|warning|negative|divider|inputs|strong/.test(value)
            ? `var(--mollie-ui-color-border-${value})`
            : value}`;
    }
    if (/icon-size/.test(property)) {
        return `var(--mollie-ui-icon-size--${value})`;
    }
    if (/flex$/.test(property)) {
        return ({
            grow: '1 1 auto',
            shrink: '0 1 auto',
            none: '0 0 auto',
        }[value] || value);
    }
    if (/align-content|align-items|align-self|justify-content/i.test(property)) {
        return ({
            start: 'flex-start',
            end: 'flex-end',
        }[value] || value);
    }
    return typeof value === 'number' &&
        value !== 0 &&
        !/animation-iteration-count|border-image-slice|border-image-width|column-count|counter-increment|counter-reset|flex-(grow|shrink)|font-size-adjust|font-weight|line-height|nav-index|opacity|order|orphans|tab-size|widows|z-index/i.test(property)
        ? `${pxToRem(value)}rem`
        : value;
}
function kebabCase(string) {
    return string
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
}
//# sourceMappingURL=responsiveCssProperties.js.map